// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r_GKTc1QQciTsV {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  align-items: flex-start;
  max-width: 100%;
  min-height: 32px;
}
.sBrAgjxtcrBxle {
  flex: 1 1 20%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.leC8WfkzmokiUl {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  align-items: flex-start;
  min-height: 32px;
  margin-left: auto;
  gap: var(--ds-space-050, 4px);
}
.RPO6eTW4FLJhI0 {
  display: inline-flex;
  position: relative;
  flex-direction: row;
  flex-grow: 1;
  flex-wrap: wrap;
  align-items: center;
  width: calc(100% - 23px);
  height: auto;
  padding: var(--ds-space-150, 12px);
  gap: var(--ds-space-050, 4px);
  container-name: boardHeader;
  container-type: inline-size;
}
@media only screen and (max-width: 900px) {
  .RPO6eTW4FLJhI0 {
    flex-wrap: wrap;
  }
}
.YGqBTGdyLiJNJB {
  position: relative;
  height: 32px;
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-0, 0px);
  float: left;
  overflow: hidden;
  font-size: 14px;
  line-height: 32px;
  cursor: default;
}
.dZ8qNSeyj9rdm0 {
  flex-grow: 1;
}
.hkanoqWDoWhmPo {
  display: flex;
  gap: var(--ds-space-050, 4px);
}
.k9rkQqZqgA9UoD {
  margin: var(--ds-space-0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardHeaderLeftSplit": `r_GKTc1QQciTsV`,
	"boardHeaderLeftSplitNoOverflow": `sBrAgjxtcrBxle`,
	"boardHeaderRightSplit": `leC8WfkzmokiUl`,
	"board-header": `RPO6eTW4FLJhI0`,
	"boardTemplateBadgeContainer": `YGqBTGdyLiJNJB`,
	"widthObserverContainer": `dZ8qNSeyj9rdm0`,
	"actionsButtons": `hkanoqWDoWhmPo`,
	"boardVisibilityButton": `k9rkQqZqgA9UoD`
};
export default ___CSS_LOADER_EXPORT___;
